var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaderState)?_c('div',{attrs:{"id":"loading"}},[_c('div',{staticClass:"dot-flashing"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }